export default __webpack_public_path__ + "static/media/19.8d6e3869.jpg";